






























import { Component, Prop, Vue } from "vue-property-decorator";
import { CPTCommentI } from "@/models/cpt/CPTCommentI";
import Markdown from "@/components/Markdown.vue";
import CommentAuthorIndicator from "@/components/CommentAuthorIndicator.vue";
import { UserRoles } from "@/models/auth/AuthenticatedUser";
@Component({
  components: {
    Markdown,
    CommentAuthorIndicator,
  },
})
/**
 * Displays a single comment of a created cpt
 */
export default class Comment extends Vue {
  /**
   * The identifier/name of the custom post type
   */
  @Prop({ required: true }) readonly comment!: CPTCommentI;

  /**
   * is comment author moderator
   */
  get isModComment(): boolean {
    return this.comment.author !== UserRoles.ANON;
  }
}
